import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCreditCardComponent } from "./med-icon-credit-card.component";

@NgModule({
  declarations: [
    MedIconCreditCardComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCreditCardComponent,
  ],
})
export class MedIconCreditCardModule { }
